export default __webpack_public_path__ + "static/NotoSans-MediumItalic-3a14d9d1c75b1caf1b7150fc0a1fd0f5.ttf";